import { render, staticRenderFns } from "./TheDisableAccountModal.vue?vue&type=template&id=1813c413&scoped=true"
import script from "./TheDisableAccountModal.vue?vue&type=script&lang=js"
export * from "./TheDisableAccountModal.vue?vue&type=script&lang=js"
import style0 from "./TheDisableAccountModal.vue?vue&type=style&index=0&id=1813c413&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1813c413",
  null
  
)

export default component.exports